require("core-js/modules/es.array.flat-map.js");
require("core-js/modules/es.array.unscopables.flat-map.js");
var _ = require('lodash');
module.exports = function (gridTemplateAreas) {
  return _.uniq(_.flatMap(gridTemplateAreas, function (row) {
    return _.flatMap(row, function (area) {
      // extract grid area names from the gridTemplate
      return _.flatMap(area.match(/[^\s]+/g), function (match) {
        if (match !== '.') {
          return match;
        }
        return [];
      });
    });
  }));
};